import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const shlink = defineConnector({
  identifier: "shlink",
  name: "Shlink",
  tagLine: "Self-hosted URL shortener",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Shlink details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://shlink.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Shlink instance.",
        },
      ],
    },
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Generate an API key using the Shlink CLI: `shlink api-key:generate`",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/rest/health`,
  },
});
